'use strict';

import { forEach, isElement, debounce } from 'lodash';
import Swal from 'sweetalert2';
import mustache from 'mustache';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { subscribe } from '../../01-helpers/event-manager';
import { setLocalStorage, getSessionStorage } from '../../01-helpers/session-manager';
import { TEETIMES_LOADED } from '../../02-const/event-names';
import saveReservation from '../../03-api/ecommerce/savereservation';
import { fillItem, pushDataLayer } from '../../05-domain/enhanced-ecommerce/items';


const
	moduleName = 'optionSelector',

	selectors = {
		base: `.js-${moduleName}`,
		template: "#optionTemplate"
	},
	filterKey = 'next-step',
	labelKey = 'labels',
	dateFormatter = Intl.DateTimeFormat('nl', {
		day: 'numeric',
		month: 'long',
		year: 'numeric'
	});

function bindEvents() {
	this.clickHandler = event => this._onClickHandler(event);
	this.baseElement.addEventListener('click', debounce(this.clickHandler, 300, {'leading': true, 'trailing': false}));
}

function confirmTeetime(result, TeeTimeJson, url) {
	if (result.value) {
		setLocalStorage('TeeTime', TeeTimeJson);
		const item = {
			Name: TeeTimeJson.CourseName,
			CourseNumber: TeeTimeJson.CourseNumber,
			Fee: '',
			category: TeeTimeJson.Time,
			category2: TeeTimeJson.Date,
			category3: TeeTimeJson.Holes,
			category4: TeeTimeJson.Players
        }

		pushDataLayer('add_to_cart', fillItem('Golfgo', item, null, 1));
		pushDataLayer('begin_checkout', fillItem('Golfgo', item, null, 1));

		saveReservation(TeeTimeJson)
			.done(result => {
				window.location.href = url;
			});
	}
}

/**
 * 
 * @param {any} template
 * @param {any} course
 */
function renderTemplate(template, data) {
	mustache.tags = ["[[", "]]"];
	const parsed = mustache.render(template, data);

	return parsed;
}

export class OptionSelector {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error('no element was found!');
			return false;
		}

		this.baseElement = baseElement;
		this.nextStep = getPageOptions(filterKey);
		this.labels = getPageOptions(labelKey);

		bindEvents.call(this);
	}

	_onClickHandler(evt) {
		// get all the data
		const
			element = evt.currentTarget,
			parent = element.parentElement,
			teetimeDataset = JSON.parse(element.dataset.teetime),
			tabDataset = JSON.parse(parent.dataset.tab),
			filterData = getSessionStorage('filters'),
			rawDate = filterData.date,
			formattedDate = dateFormatter.format(new Date(rawDate)),
			data = {
				CourseName: tabDataset.courseName,
				holes: filterData.holes,
				date: formattedDate,
				time: teetimeDataset.time,
				loop: tabDataset.loopName
			},
			template = document.querySelector(selectors.template).innerHTML,
			parsed = renderTemplate(template, data);

		// set local storage
		const TeeTimeJson = {
			"CourseNumber": tabDataset.courseId,
			"CourseName": tabDataset.courseName,
			"Loop1": teetimeDataset.loop1,
			"Loop2": teetimeDataset.loop2,
			"DateTime": `${rawDate} ${teetimeDataset.time}`,
			"Date": data.date,
			"Time": teetimeDataset.time,
			"Holes": data.holes,
			"LoopName": data.loop,
			"Players": filterData.players
		};
		
		// configure and show the Sweet Alert
		Swal.fire({
			title: tabDataset.CourseName,
			html: parsed,
			confirmButtonColor: '#ed4040',
			confirmButtonText: `${this.labels.confirm}`
		}).then((result) => {
			confirmTeetime(result, TeeTimeJson, this.nextStep);
		});
	}
}

const initOptionSelector = () => {
	subscribe(TEETIMES_LOADED, () => {
		forEach(document.querySelectorAll(selectors.base), resultsElement => {
			const optionSelector = new OptionSelector(resultsElement);
		});
	});
}

initOptionSelector();


